export const LOCALES_WITH_REGION = ['en-US', 'da-dk', 'de-de', 'pl-PL'];
export const DEFAULT_LOCALE = 'en-US';
export const DEFAULT_CHINA_LOCALE = 'zh-CN';
export const DEFAULT_SC_LOCALE = 'en';
export const SUPPORTED_SITE_LOCALES = [
  'en-au',
  'en-ca',
  'fr-ca',
  'cs-cz',
  'da-dk',
  'de-de',
  'es-es',
  'fr-fr',
  'en-gb',
  'en-ie',
  'en-my',
  'it-it',
  'es-mx',
  'nl-nl',
  'nb-no',
  'en-nz',
  'pl-pl',
  'ro-ro',
  'de-ch',
  'fi-fi',
  'sv-se',
  'tr-tr',
  'pt-br',
  'en',
  'ko-kr',
  'zh-cn',
  'en-hk',
  'ja-jp',
  'en-sg',
  'en-in',
  'en-apac',
  'en-emea',
  'en-mea',
  'fr-mea',
];
